module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("1")])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Overview of International Upstream Operations")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("P")]), _vm._v("etroleum operations"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-2"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-3"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-4"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-5"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-6"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-7"
    }
  }, [_vm._v(" are generally divided into upstream activities—exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-8"
    }
  }, [_vm._v(" and production, midstream activities—gathering and transportation, or downstream activities—refining, and marketing activities. Upstream")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-9"
    }
  }, [_vm._v(" oil and gas exploration and production operations")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-10"
    }
  }, [_vm._v(" involve high-cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-11"
    }
  }, [_vm._v(", high-risk activities that present numerous unique challenges to accountants worldwide. This book focuses on accounting for upstream activities of companies engaged in international oil and gas operations. Chapter 1 provides a brief introduction to operations encountered in upstream operations that are essential to understanding the discussions throughout this book. The remaining chapters discuss various topics related to accounting for international oil and gas upstream operations, including the following:")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-11"
    }
  }, [_vm._v("overview of mineral ownership")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-12"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-13"
    }
  }, [_vm._v(", contracts,")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-14"
    }
  }, [_vm._v(" and fiscal policies encountered in international upstream operations")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-14"
    }
  }, [_vm._v("accounting standards and methods encountered in international upstream operations")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-14"
    }
  }, [_vm._v("reserves measurement and reporting")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-14"
    }
  }, [_vm._v("disclosures often required for oil and gas producing companies")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-14"
    }
  }, [_vm._v("International Financial Accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-15"
    }
  }, [_vm._v(" and Reporting Standards")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-15"
    }
  }, [_vm._v("The vision of a single set of globally accepted accounting standards has existed for many years. The first international standard-setting body was the International Accounting Standards Committee (IASC) which was formed in 1973. (See Appendix D: Acronyms")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-16"
    }
  }, [_vm._v(" Commonly Used in the International Petroleum Industry.) The IASC issued numerous International Accounting Standards (IAS), which, to some extent, were used in over 100 countries. Many forces, including the formation of the European Union in 1993 and the global evolution of securities markets, resulted in a broad effort to accelerate development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-17"
    }
  }, [_vm._v(" of a single set of high-quality, internationally accepted financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-18"
    }
  }, [_vm._v(" and reporting standards. As a consequence of these endeavors, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("the IASC was replaced by the International Accounting Standards Board (IASB")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-19"
    }
  }, [_vm._v(") in 2001. Since its establishment, the IASB has methodically revised and updated most existing IAS (originally issued by the IASC) and issued a number of additional standards or International Financial Reporting Standards (IFRS")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-20"
    }
  }, [_vm._v("). Collectively the IASB’s body of authoritative standards is referred to as IFRS, which includes both IAS and IFRS guidance.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-20"
    }
  }, [_vm._v("While substantial progress toward harmonization of international financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-21"
    }
  }, [_vm._v(" and reporting standards has occurred, no single set of international financial accounting standards currently exists. IFRS")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-22"
    }
  }, [_vm._v(" have been adopted in some countries; however, many countries have opted to continue to rely, at least to some extent, on national accounting standards. A substantial number of countries halted or dissolved their national accounting standard-setting process and now mandate use of IFRS as their solely accepted financial accounting and reporting standards. However, many countries continue to rely on national accounting standards boards or advisory groups to establish and maintain a national generally accepted accounting principles (GAAP)")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-23"
    }
  }, [_vm._v(". In these jurisdictions, use of domestic GAAP is typically required for local statutory financial accounting and reporting purposes; however, for companies whose securities are traded in markets outside their home country, financial statements conversion or reconciliation to the standards adopted by the particular exchange may be required. In some instances, national accounting standards are largely harmonized with those issued or adopted by the IASB")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-24"
    }
  }, [_vm._v("; however, in some countries local GAAP")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-25"
    }
  }, [_vm._v(" bears little resemblance to IFRS")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-26"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-26"
    }
  }, [_vm._v("In the United States, the establishment and enforcement of financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-27"
    }
  }, [_vm._v(" standards and regulations for public companies fall under the jurisdiction of the U.S. Securities and Exchange Commission (SEC)")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-28"
    }
  }, [_vm._v(". The Financial Accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-29"
    }
  }, [_vm._v(" Standard Board (FASB)")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-30"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-31"
    }
  }, [_vm._v(" is a private, standard-setting body in the U.S. that issues standards and guidance that establishes U.S. GAAP")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-32"
    }
  }, [_vm._v(". The SEC and FASB work closely in the development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-33"
    }
  }, [_vm._v(", revision, and implementation of newly issued standards and guidelines. When the SEC adopts newly issued or revised FASB standards, use of those standards becomes mandatory for U.S. companies that are traded in the U.S. financial markets. Historically, all foreign registrants not using U.S. GAAP were required to reconcile their reported balance sheets and income statements to U.S. GAAP (referred to as 40-F reconciliation for Canadian filers and 20-F reconciliation for all other foreign filers). In 2007, the SEC eliminated the reconciliation requirement for foreign registrants whose financial statements are prepared in accordance with IFRS")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-34"
    }
  }, [_vm._v(" as issued by the IASB")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-35"
    }
  }, [_vm._v(". Foreign registrants using international accounting standards other than those issued by the IASB, such as national accounting standards, must continue to include the mandatory reconciliation to U.S. GAAP in their financial statements filed with the SEC.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-35"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Oil and Gas Industry-Specific Accounting Standards")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-35"
    }
  }, [_vm._v("While countries have issued industry-specific oil and gas accounting standards as part of their national GAAP, perhaps the most widely accepted oil and gas industry-specific accounting standards are those of the United States. The SEC"), _c('i', [_vm._v(" Reg. S-X")])]), _c('i', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-36"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-36"
    }
  }, [_vm._v(" details the requirements relating to content and format of financial statements and reports filed by publicly traded companies in the United States. SEC"), _c('i', [_vm._v(" Reg. S-X Rule 4-10")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-37"
    }
  }, [_vm._v(", “Financial Accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-38"
    }
  }, [_vm._v(" and Reporting for Oil and Gas Producing Activities,” details the specific accounting rules and regulations that must be utilized by U.S. domestic registrants engaged in “oil and gas producing activities.”"), _c('i', [_vm._v(" Reg. S-X Rule 4-10")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-39"
    }
  }, [_c('i', [_vm._v("(a)(16)")]), _vm._v(" defines oil and gas producing")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-40"
    }
  }, [_vm._v(" activities as including:")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-40"
    }
  }, [_vm._v("The search for crude oil, including condensate and natural gas liquids in their natural states and original locations.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-40"
    }
  }, [_vm._v("The acquisition of property rights or properties for the purpose of exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-41"
    }
  }, [_vm._v(" and/or production of oil and gas.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-41"
    }
  }, [_vm._v("The construction, drilling, and production activities necessary to remove oil and gas from natural reservoirs, including lifting the oil and gas to the surface, gathering, treating, field processing, and field storage.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-41"
    }
  }, [_vm._v("The extraction of saleable hydrocarbons, in the solid, liquid, or gaseous state, from oil sands, shale, coal beds, or other nonrenewable natural resources which are intended to be upgraded into synthetic oil or gas, and activities undertaken with a view to such extraction.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-41"
    }
  }, [_vm._v("Collectively these activities are often referred to as exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-42"
    }
  }, [_vm._v(" and production, or E&P"), _c('i')]), _c('i', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-43"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-43"
    }
  }, [_vm._v(", operations. A company engaged in upstream operations is often referred to as an E&P company.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-43"
    }
  }, [_vm._v("The SEC’s definition of oil and gas producing")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-44"
    }
  }, [_vm._v(" activities specifically"), _c('i', [_vm._v(" excludes")]), _vm._v(" the following from its definition of oil and gas producing activities:")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-44"
    }
  }, [_vm._v("Transportation, refining, or marketing of oil and gas")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-44"
    }
  }, [_vm._v("Activities relating to the production of natural resources other than oil, gas, or natural resources from which synthetic oil and gas can be extracted")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-44"
    }
  }, [_vm._v("Production of geothermal steam")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-44"
    }
  }, [_vm._v("Thus, in summary, the classification of oil and gas activities as being upstream oil and gas producing activities as opposed to midstream or downstream is of special significance in accounting. This is because the specialized financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-45"
    }
  }, [_vm._v(" and reporting rules and standards that appear in SEC"), _c('i', [_vm._v(" Reg. S-X Rule 4-10")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-46"
    }
  }, [_vm._v(" apply only to upstream operations. Midstream operations in the oil and natural gas industry basically are the link between upstream and downstream. Midstream operations")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-47"
    }
  }, [_vm._v(" include the activities and infrastructure necessary to move and store crude oil and natural gas after it leaves the production site and involves transportation, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("storage, and wholesale marketing. Downstream operations")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-48"
    }
  }, [_vm._v(" involve activities and infrastructure necessary to refine and process crude oil and natural gas into finished products and commercial marketing of those products. In accounting, the distinction between upstream versus midstream and downstream operations is of particular importance. Often industry-specific financial accounting and reporting standards must be applied in accounting for upstream activities while more general-purpose accounting standards and practices apply to midstream and downstream operations. The U.S. GAAP")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-49"
    }
  }, [_vm._v(" and IFRS")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-50"
    }
  }, [_vm._v(" accounting and reporting standards and requirements that apply to upstream oil and gas operations are described in detail throughout this book.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-50"
    }
  }, [_vm._v("International Industry Structure")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-50"
    }
  }, [_vm._v("The accounting issues faced by companies operating in the international petroleum industry are largely related to the economics and structure of the industry. The structure of exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-51"
    }
  }, [_vm._v(" and production activities in each country is largely related to laws governing ownership")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-52"
    }
  }, [_vm._v(" of natural resources, specifically oil and gas mineral rights.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-52"
    }
  }, [_vm._v("Ownership of oil and gas mineral rights and natural resources in the U.S. differs from most other countries in the world. The history of ownership of mineral")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-53"
    }
  }, [_vm._v(" rights and natural resources in the U.S. can be traced back to the nineteenth century when the federal government passed various laws and acts providing for private ownership of lands along with the natural resources within them. As a consequence, ownership of oil and gas mineral rights in the U.S. originates with ownership of the land and, for onshore locations, includes everything that lies under the surface of the ground extending down to the center of the earth.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-53"
    }
  }, [_vm._v("Land ownership")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-54"
    }
  }, [_vm._v(" in the U.S. can be divided into three groups: individuals and corporations; federal, state, and local governments; and Native American tribes. Private lands are those owned by individuals and corporations. Federal, state, and local government lands include those owned by or under the jurisdiction of the federal government or by a particular state or local government. Submerged lands along the coastline of a state and extending out three miles are owned by the individual state. Submerged lands extending 200 nautical miles beyond the states’ offshore boundaries are owned by the U.S. federal government. Government-owned lands also include those lands ceded to a federal, state, or local government through purchase, treaty, grant, or condemnation proceedings. Examples include national and state parks, railroad right of ways, military bases, etc. Native American lands include lands held in trust by the federal government for a tribe as a consequence of treaties, laws, and litigation.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-54"
    }
  }, [_vm._v("While the ownership of mineral")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-55"
    }
  }, [_vm._v(" and natural resources originates with the land, the mineral rights can be legally severed or separated from the surface. The surface owner generally owns the topsoil including buildings, dwellings, the right to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("till the land for crops or gardens and plant trees, and can dig into the land to drill water wells or bury similar equipment. A landowner may sell or convey the surface rights and retain the mineral rights, sell or convey the mineral rights and retain the surface rights, or sell/convey the surface rights to one party and the mineral rights to another. Furthermore, many different parties can jointly own the mineral rights under a particular parcel of land. This often occurs as a result of inheritance since passing mineral rights through families for multiple generations is commonplace. Today, in the U.S. much of the private land has surface owners that are different from the owners of the mineral rights. Therefore, oil and gas companies wishing to obtain a mineral interest")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-56"
    }
  }, [_vm._v(" in the U.S. typically do so by executing lease agreements with the individuals, corporations, or governmental entity that owns or controls the mineral rights.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-56"
    }
  }, [_vm._v("While some countries outside the U.S. have private ownership of mineral")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-57"
    }
  }, [_vm._v(" rights, sovereign ownership of minerals is by far the most common. Sovereign ownership includes direct government ownership of mineral rights or indirect government control through a sovereign-owned oil company set up specifically for the purpose of administering the country’s petroleum fiscal regime. For example, in Malaysia the"), _c('i', [_vm._v(" Petroleum Development Act of 1974")]), _vm._v(" irrevocably gives “The entire ownership in, and the exclusive rights, powers, liberties and privileges of exploring, exploiting, winning and obtaining petroleum whether onshore or offshore of Malaysia” to PETRONAS (Petroleum Nasional Berhad). However, according to the"), _c('i', [_vm._v(" Act")]), _vm._v(", PETRONAS is “subject to the control and direction of the Prime Minister who may from time to time issue such direction as he may deem fit.” Malaysia’s model is not uncommon where the sovereign oil company only operates within its home country. However, it is increasingly commonplace for sovereign oil companies to establish subsidiaries that operate outside of their home countries. Examples include the China National Offshore Oil Company (CNOOC) and China National Petroleum Company (CNPC), two of the major national oil and gas companies of the People’s Republic of China, both of which have subsidiaries (i.e."), _c('i', [_vm._v(",")]), _vm._v(" CNOOC Limited and PetroChina) that operate in a number of countries outside of China PR and are traded on major stock exchanges outside of China.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-57"
    }
  }, [_vm._v("In some countries the government has recently expanded the role of the state oil company. For example, the Brazilian government recently strengthened the role of Petroleo Brasileiro (Petrobras) in optimizing the Brazilian oil and gas industry. Other countries, such as Mexico, have followed Brazil’s lead. Notably, some governments have actually moved to privatize their state-owned oil companies. Examples include France (Total), Spain (Repsol), and Italy (Ente Nazionale Idrolcarburi (ENI)). In the U.S. there are no state-owned oil companies. Regardless of the role of the state oil company, in most cases, oil and gas companies seeking to obtain mineral rights outside the United States must contract with the relevant governmental authority or state-owned oil company in the country in which the property is located. The oil and gas contracts often utilized in acquiring mineral rights in international operations are discussed in detail in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002"
    }
  }, [_vm._v("chapter 2")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Overview of Upstream"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-58"
    }
  }, [_vm._v(" Operations")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-58"
    }
  }, [_vm._v("Upstream")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-59"
    }
  }, [_vm._v(" oil and gas operations do not occur in any particular order or by following any specific set of trends or rules; however, the phase in which certain costs are incurred may be important in accounting for upstream activities. For example, some oil and gas contracts encountered in international operations require sorting upstream oil and gas activities into various phases. In those contracts,")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-60"
    }
  }, [_vm._v(" the timing of occurrence of specific events (i.e., official sanctioning of a discovery of oil or gas reserves, approval of development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-61"
    }
  }, [_vm._v(" plans, signing of oil or gas sales agreements, etc.) largely dictate how costs and revenues are shared by the various parties. In addition, in making capitalization versus expense decisions for financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-62"
    }
  }, [_vm._v(" purposes, the timeline of operations for a specific area or field in which the costs are incurred may be helpful in evaluating the uncertainty associated with the costs and thus the potential for future economic benefit")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-63"
    }
  }, [_vm._v(". Although the phase does not necessarily dictate the financial accounting treatment, accounting standard setters and company accountants typically consider the phase of operations during which the expenditure was made as a major factor in the decision of whether to capitalize or expense a cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-64"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-64"
    }
  }, [_vm._v("An important point that must be understood is that the capitalization versus expense treatment of costs for financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-65"
    }
  }, [_vm._v(" purposes is not dictated by how costs are defined and treated in various oil and gas contracts. This fact often results in much confusion, particularly in international joint operations. These differences and the rationale behind the differing treatments are explained in more detail throughout this book.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig1-1"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-65"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 1-1. Conceptual timeline of upstream oil and gas operations",
      "src": "images/Fig1-1.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-65"
    }
  }, [_c('b', [_vm._v("Fig. 1-1.")]), _vm._v(" Conceptual timeline of upstream oil and gas operations")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig1-1"
    }
  }, [_vm._v("Figure 1-1")]), _vm._v(" is a conceptual timeline of typical upstream oil and gas operations. While oil and gas operations do not occur in any specific order, this conceptual timeline may be helpful in understanding issues around the timing or phases "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("during which certain costs may be incurred. In addition, certain accounting decisions are dependent on the stage of operations. The accounting-related issues are discussed in detail in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#chap-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4")]), _vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is difficult to identify geological and geophysical (G&G"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-66"
    }
  }, [_vm._v(")")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-67"
    }
  }, [_vm._v(" exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-68"
    }
  }, [_vm._v(" with any particular phase of operations. In some locations, such as offshore U.S. federal lands, E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-69"
    }
  }, [_vm._v(" companies may be allowed to conduct G&G")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-70"
    }
  }, [_vm._v(" exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-71"
    }
  }, [_vm._v(" prior to contracting to obtain mineral rights in the specific area while in other locations any exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-72"
    }
  }, [_vm._v(" prior to obtaining mineral rights is strictly prohibited. In some locations, exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-73"
    }
  }, [_vm._v(" permits may be obtained prior to mineral contracts being executed. While there is no single template that is followed, G&G")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-74"
    }
  }, [_vm._v(" exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-75"
    }
  }, [_vm._v(" activities generally do not extend beyond the development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-76"
    }
  }, [_vm._v(" phase for a particular field unless new information or technology justifies exploring for the presence of undiscovered petroleum.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-76"
    }
  }, [_vm._v("G&G")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-77"
    }
  }, [_vm._v(" exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-78"
    }
  }, [_vm._v(" refers to activities undertaken to identify areas under the earth’s surface that may contain oil and gas reserves. Geological methods rely on the identification of rocks and minerals on or near the surface and the understanding of the environments in which they were formed. These methods may include the use of aerial photography, satellite imaging, imaging radar, and topographical and geological mapping. Such methods are aimed at gathering data about surface features that can be used to make inferences regarding the potential existence of petroleum-bearing subsurface formations.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-78"
    }
  }, [_vm._v("Geophysical methods involve studies aimed at locating and detecting the presence of subsurface structures and determining their size, shape, depth, and physical properties. These methods are utilized to identify the presence of certain physical characteristics that may be indicative of oil and gas reservoirs. Geophysical methods include gravitational studies, magnetic and electromagnetic evaluation, and seismic studies.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-78"
    }
  }, [_vm._v("Seismic")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-79"
    }
  }, [_vm._v(" studies provide detailed information about subsurface structures by recording the reflection of sound waves on subsurface formations. While seismic studies may be used in exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-80"
    }
  }, [_vm._v(" for oil and gas, advances in seismic technology make it broadly used in field development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-81"
    }
  }, [_vm._v(" and production planning. Time-lapse, or 4-D seismic, involves repeating a series of 3-D seismic surveys over time in order to monitor how certain reservoir")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-82"
    }
  }, [_vm._v(" properties (i.e., movement of fluids, temperature, and pressure) change in response to production. In this way, the movement of oil, gas, and/or water can be anticipated before it affects production. Therefore, the use of seismology is no longer limited solely to exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-83"
    }
  }, [_vm._v(" and, in some locations, may be used throughout the life of production.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-83"
    }
  }, [_vm._v("The first four phases in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig1-1"
    }
  }, [_vm._v("Figure 1-1")]), _vm._v(" may be referred to collectively as preproduction phases although it is possible for substantial levels of production to occur during the development"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-84"
    }
  }, [_vm._v(" phase. The sequencing of the phases is not identical for all companies or for all projects. Moreover, in any particular operation and/or company, two or more of these phases may well be combined into a single phase; for "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("example, pre-license")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-85"
    }
  }, [_vm._v(" prospecting and exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-86"
    }
  }, [_vm._v(" or production and closure. In addition, the phases will almost certainly overlap: for example, exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-87"
    }
  }, [_vm._v(" during the development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-88"
    }
  }, [_vm._v(" phase or production during the development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-89"
    }
  }, [_vm._v(" phase.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-001"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-89"
    }
  }, [_vm._v("Pre-property Acquisition")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-89"
    }
  }, [_vm._v("Pre-property acquisition (sometimes referred to as pre-license")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-90"
    }
  }, [_vm._v(" exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-91"
    }
  }, [_vm._v(") typically involves the geological evaluation of relatively large areas before acquisition of any petroleum rights. The activities involved in pre-license")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-92"
    }
  }, [_vm._v(" prospecting vary widely but are usually general in scope and are not necessarily part of an integrated project. For example, sometimes companies purchase G&G")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-93"
    }
  }, [_vm._v(" covering fairly large areas of a country (frequently referred to as a library). Other activities include researching and analyzing an area’s historic geologic data, carrying out G&G")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-94"
    }
  }, [_vm._v(" studies, or assessing topographical information. Definitions of oil and gas industry terms may be found on the U.S. Energy Information Administration website (")]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.eia.gov",
      "target": "_blank"
    }
  }, [_vm._v("www.eia.gov")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Some pre-property acquisition activities may be undertaken without having physical access to the area; however, usually pre-property acquisition cannot take place without first obtaining permission from the owner of the land and/or the mineral rights. Satellite imagery, aerial photographs, gravity-meter tests, magnetic measurements, and various similar observations or measurements are often used to target specific areas without having to physically enter onto the property. Geologists may also study areas where the rock formations are readily observable, i.e., in mountainous areas or where roads or railways have been constructed. More detailed evaluation of an area of interest, such as conducting seismic testing, requires specific permission or approval since such activities involve physical testing on the site.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In locations where the local or federal government owns the mineral rights, the program the government has in place largely determines the extent and nature of any pre-property acquisition exploration"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-95"
    }
  }, [_vm._v(" that may occur. If the government is actively seeking to contract with foreign E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-96"
    }
  }, [_vm._v(" companies for oil and gas exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-97"
    }
  }, [_vm._v(" and production, it may be quite eager to accommodate companies by allowing them access to specific areas of potential interest. In some situations, companies may be required to purchase G&G")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-98"
    }
  }, [_vm._v(" information directly from the government as a prerequisite to negotiating for acquisition of mineral rights. In these situations, companies may find it necessary to acquire such data whether or not the company regards the data as being especially beneficial.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-98"
    }
  }, [_vm._v("Accounting for pre-property acquisition activities may be challenging in financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-99"
    }
  }, [_vm._v(" since it occurs before petroleum rights have been acquired for the area on which the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-100"
    }
  }, [_vm._v(" is conducted. Capitalization versus expense-type financial accounting decisions are affected by the level of certainty (or uncertainty) regarding the future economic benefits that will accrue to the company as a result of the expenditures in question. Some accountants argue that general "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("exploration")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-101"
    }
  }, [_vm._v(" occurring prior to the acquisition of petroleum rights should be expensed since (a) the certainty of future economic benefits")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-102"
    }
  }, [_vm._v(" is very low and (b) the right to those benefits does not rest with the company at the time the expenditures are made. Others argue that all exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-103"
    }
  }, [_vm._v(" activities collectively represent a company’s efforts to find and produce oil and gas reserves, and therefore the timing of the activity (i.e., before or after petroleum rights acquisition) is irrelevant. As will be seen in later chapters, these various points of view have resulted in two very different methods of accounting (the successful efforts method")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-104"
    }
  }, [_vm._v(" and the full cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-105"
    }
  }, [_vm._v(" method) as well as differences between U.S. GAAP")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-106"
    }
  }, [_vm._v(" and IFRS")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-107"
    }
  }, [_vm._v(".")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-002"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-107"
    }
  }, [_vm._v("Mineral Right Acquisition")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-108"
    }
  }, [_vm._v(" and Contracting")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-108"
    }
  }, [_vm._v("Mineral right acquisition involves the activities related to obtaining the legal right to explore for, develop, and produce oil or gas in a particular area. In operations in the U.S., these legal rights are acquired by entering into a lease agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-109"
    }
  }, [_vm._v(" with the mineral interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-110"
    }
  }, [_vm._v(" owner(s). In most locations outside the U.S. these legal rights are acquired by entering into any one of any number of different types of mineral contracts either with the government directly or through a state-owned oil company. Examples of these contracts include leases, concession agreements, production-sharing contracts,")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-111"
    }
  }, [_vm._v(" and risk-service contracts")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-112"
    }
  }, [_vm._v(". Accounting issues related to certain petroleum contracts is discussed in detail in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002"
    }
  }, [_vm._v("chapter 2")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The type of contract executed in the U.S. between the individual mineral rights owner(s) and the company seeking to explore, develop, and produce oil and gas from the property is an oil and gas lease"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-113"
    }
  }, [_vm._v(". Lease agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-114"
    }
  }, [_vm._v(" are also used when contracting with the government for mineral rights")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-115"
    }
  }, [_vm._v(" in the United Sates. Outside the United States the contracts executed between the government and E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-116"
    }
  }, [_vm._v(" companies are quite varied. Concession agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-117"
    }
  }, [_vm._v(" are quite popular and are used by many governments, including the UK, Canada, and Australia. Perhaps the most commonly used contract is the production-sharing contract (PSC)")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-118"
    }
  }, [_vm._v(" or production-sharing agreement (PSA)")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-119"
    }
  }, [_vm._v(". This contract is used to acquire petroleum rights in many countries, including Indonesia, Malaysia, China, Thailand, Angola, and Nigeria, to name a few. Risk-service agreements are less popular but nevertheless are also used in contracting for the right to explore and produce oil and gas. Risk-service")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-120"
    }
  }, [_vm._v(" agreements have been used in such countries as Venezuela, Bolivia, and Kuwait.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-003"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-120"
    }
  }, [_vm._v("Lease agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-121"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-121"
    }
  }, [_vm._v("An oil and gas lease")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-122"
    }
  }, [_vm._v(" grants to an E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-123"
    }
  }, [_vm._v(" company")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-124"
    }
  }, [_vm._v(" the right (and obligation) to operate a property. This includes the right to explore for, develop, and produce oil and gas from the property and also obligates the company to pay all costs. The type of interest owned by the E&P company that obligates it to pay all of the costs of upstream exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-125"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-126"
    }
  }, [_vm._v(", and operations is a"), _c('b', [_vm._v(" working interest")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-127"
    }
  }, [_c('b', [_vm._v(",")]), _vm._v(" and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("the E&P company is a working interest owner")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-128"
    }
  }, [_vm._v(". There can be multiple working interest owners in the same property. The typical mineral lease calls for:")])]), _c('ol', {
    staticClass: "liste_alpha"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-128"
    }
  }, [_vm._v("Payment of a bonus, often referred to as a signature bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-129"
    }
  }, [_vm._v(", by the lessee (i.e., an E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-130"
    }
  }, [_vm._v(" company) to the lessor (the mineral interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-131"
    }
  }, [_vm._v(" owner) at the time the contract is signed;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-131"
    }
  }, [_vm._v("Payment of a royalty")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-132"
    }
  }, [_vm._v(" equal to a specified percentage of the value of the oil and gas produced or an in-kind payment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-133"
    }
  }, [_vm._v(" of a specified portion of oil and gas production. In-kind payments")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-134"
    }
  }, [_vm._v(" involve payment in physical quantities of oil and gas as opposed to payment in money;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-134"
    }
  }, [_vm._v("The lessee being responsible for payment of all of the upstream exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-135"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-136"
    }
  }, [_vm._v(", and operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-137"
    }
  }, [_vm._v(" and incurrence of all of the risks associated with exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-138"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-139"
    }
  }, [_vm._v(", and production without reimbursement from the lessor;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-139"
    }
  }, [_vm._v("The lease remaining in effect indefinitely, so long as minerals continue to be produced from the property.")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-139"
    }
  }, [_vm._v("In addition to paying a royalty and paying the costs incurred in exploring, developing, and operating the property, the lessee may be responsible for paying a variety of taxes, duties, and fees.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-004"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-139"
    }
  }, [_vm._v("Concession agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-140"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-140"
    }
  }, [_vm._v("Concession agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-141"
    }
  }, [_vm._v(" are similar to lease agreements. The primary difference is that concession agreements are encountered in operations outside the U.S. where the mineral rights are owned by the local government. In addition, some concession agreements provide for government participation (through a state-owned oil company) in the form of a joint working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-142"
    }
  }, [_vm._v(". Typical provisions found in a concession agreement are:")])]), _c('ol', {
    staticClass: "liste_alpha"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-142"
    }
  }, [_vm._v("Payment of a bonus by the foreign E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-143"
    }
  }, [_vm._v(" company to the government at the time the contract is signed or at specified points during development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-144"
    }
  }, [_vm._v(" and/or production;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-144"
    }
  }, [_vm._v("Payment of a royalty")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-145"
    }
  }, [_vm._v(" equal to a specified percentage of the value of the oil and gas produced or an in-kind payment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-146"
    }
  }, [_vm._v(" of a specified portion of oil and gas production;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-146"
    }
  }, [_vm._v("The contractor (i.e., the non-government oil and gas company(ies) involved in the contract) being responsible for payment of all of the costs and incurrence of all of the risks")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-147"
    }
  }, [_vm._v(" associated with exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-148"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-149"
    }
  }, [_vm._v(", and production without reimbursement;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-149"
    }
  }, [_vm._v("The agreement remaining in effect indefinitely, so long as minerals continue to be produced from the contract area.")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-149"
    }
  }, [_vm._v("As with a lease agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-150"
    }
  }, [_vm._v(", the E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-151"
    }
  }, [_vm._v(" company")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-152"
    }
  }, [_vm._v(" is responsible for paying all of the costs incurred in exploring, developing, and operating the properties in the license")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-153"
    }
  }, [_vm._v(" area. In addition to paying a royalty")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-154"
    }
  }, [_vm._v(" and paying the costs incurred in exploring, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("developing, and operating the property, the E&P company may be responsible for paying a variety of taxes")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-155"
    }
  }, [_vm._v(", including income and value-added taxes (as well as duties and fees). In addition, in some countries, such as the U.K., Australia, and Trinidad, additional taxes on petroleum profits may also be assessed.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-005"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-155"
    }
  }, [_vm._v("Production sharing contracts (PSCs)")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-156"
    }
  }, [_vm._v(" and agreements (PSAs)")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-157"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-157"
    }
  }, [_vm._v("Production sharing contracts and agreements are arrangements by which E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-158"
    }
  }, [_vm._v(" companies obtain the rights from the government or state-owned oil companies to explore for, develop, and produce oil and gas (from this point on, the term PSC will be used). While the specific form and content of PSCs vary from country to country, and even within a single country, the following features are likely to be encountered:")])]), _c('ol', {
    staticClass: "liste_alpha"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-158"
    }
  }, [_vm._v("The contractor pays a bonus to the national government at the time the contract is signed. Additionally, development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-159"
    }
  }, [_vm._v(" bonuses may be required if the operation goes into development and/or production bonuses")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-160"
    }
  }, [_vm._v(" when predefined production levels are achieved;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-160"
    }
  }, [_vm._v("The contractor pays royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-161"
    }
  }, [_vm._v(" to the national government as production occurs;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-161"
    }
  }, [_vm._v("The national government retains ownership of the minerals")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-162"
    }
  }, [_vm._v(" in the ground. It simply grants the contractor the right to explore for, develop, and produce the reserves;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-162"
    }
  }, [_vm._v("The contractor is required to bear all of the costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-163"
    }
  }, [_vm._v(" and risks related to exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-164"
    }
  }, [_vm._v(" with the government (through a state-owned oil company) having the option to participate in development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-165"
    }
  }, [_vm._v(" and/or production as a working interest owner")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-166"
    }
  }, [_vm._v(";")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-166"
    }
  }, [_vm._v("The contractor is required to either spend a predetermined amount of money on training")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-167"
    }
  }, [_vm._v(" for the local staff or give that amount of money to the government so that they can provide the training. This cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-168"
    }
  }, [_vm._v(" may be recoverable from future production;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-168"
    }
  }, [_vm._v("The contractor is required to perform certain work aimed toward developing the infrastructure of the host country. For example, the contractor may be required to build roads, schools, potable water and sewer systems, or hospitals. The costs associated with infrastructure development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-169"
    }
  }, [_vm._v(" may not be recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-170"
    }
  }, [_vm._v(" from future production;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-170"
    }
  }, [_vm._v("Exploration, development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-171"
    }
  }, [_vm._v(", and operating costs"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-172"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-172"
    }
  }, [_vm._v(" are recoverable out of a specified percentage of production. The estimated volume of oil or gas production necessary to recover the agreed upon costs is referred to as"), _c('b', [_vm._v(" cost")])]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-173"
    }
  }, [_vm._v(" oil")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-173"
    }
  }, [_vm._v(";")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-173"
    }
  }, [_vm._v("A contractually agreed upon amount of production is referred to as"), _c('b', [_vm._v(" profit oil")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-174"
    }
  }, [_vm._v(", typically split between the government, state-owned oil company, and the contractor on a predetermined basis.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-174"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("Consistent with the lease and concessionary environment, the contractor is typically responsible for various taxes including taxes on its income generated in the country.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-006"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-174"
    }
  }, [_vm._v("Risk-service contracts")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-175"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-175"
    }
  }, [_vm._v("Another type of contract encountered in international operations is a risk-service contract")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-176"
    }
  }, [_vm._v(". Risk-service contracts")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-177"
    }
  }, [_vm._v(" may be used in areas where oil and gas production had been achieved, but the need existed to rejuvenate the field or production area. The “service” provided by the oil and gas producing company was typically in the form of performing workover")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-178"
    }
  }, [_vm._v("s and other operations aimed at restoring or stimulating production including application of current technology to currently producing fields. Risk-service contracts may also be executed in unproved areas with the service being defined to include exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-179"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-180"
    }
  }, [_vm._v(", and production of any reserves that might be discovered. There is no standard risk-service contract; however, risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-181"
    }
  }, [_vm._v(" often include the following features:")])]), _c('ol', {
    staticClass: "liste_alpha"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-181"
    }
  }, [_vm._v("Payment of a bonus to the national government at the time the contract is signed;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-181"
    }
  }, [_vm._v("Payment of royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-182"
    }
  }, [_vm._v(" to the national government as production occurs;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-182"
    }
  }, [_vm._v("Retention of ownership of the reserves")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-183"
    }
  }, [_vm._v(" by the national government (since the contractor is deemed to be providing a service);")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-183"
    }
  }, [_vm._v("All of the costs and risks related to exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-184"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-185"
    }
  }, [_vm._v(", and production being borne by the contractor;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-185"
    }
  }, [_vm._v("Operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-186"
    }
  }, [_vm._v(" and capital costs incurred by the contractor being recovered through payment of operating fees and capital fees;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-186"
    }
  }, [_vm._v("The contractor also being entitled to fees (over and above operating and capital fees) which are designed to provide a profit to the contractor;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-186"
    }
  }, [_vm._v("The government (through a state-owned oil company) having the right to participate in operations as a working interest owner.")])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-007"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-186"
    }
  }, [_vm._v("Exploration Operations")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-186"
    }
  }, [_vm._v("Exploration involves the detailed examination of an area for which a mineral interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-187"
    }
  }, [_vm._v(" has been acquired. Generally, the geographical area has demonstrated sufficient potential to justify further exploration to determine whether oil and gas are present in commercial quantities. The activities involved in exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-188"
    }
  }, [_vm._v(" are similar to those in the pre-license")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-189"
    }
  }, [_vm._v(" prospecting phase; however, they are usually concentrated on a more localized geographical area and may include G&G")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-190"
    }
  }, [_vm._v(" studies and exploratory drilling.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-190"
    }
  }, [_vm._v("Financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-191"
    }
  }, [_vm._v(" for exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-192"
    }
  }, [_vm._v(" costs may be challenging since the costs incurred are likely to be quite large while the likelihood of future economic benefit is highly uncertain. Some accountants believe that if the uncertainty is sufficiently "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("high, all exploration")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-193"
    }
  }, [_vm._v(" phase costs should be expensed as incurred. Other accountants would treat exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-194"
    }
  }, [_vm._v(" costs in a manner consistent with the cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-195"
    }
  }, [_vm._v(" of acquisition or construction of a productive asset. The specific accounting treatment of the various exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-196"
    }
  }, [_vm._v("-related costs under U.S. GAAP")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-197"
    }
  }, [_vm._v(" and IFRS")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-198"
    }
  }, [_vm._v(" are discussed in detail in subsequent chapters of this book.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-008"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-198"
    }
  }, [_vm._v("Evaluation and Appraisal Operations")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-199"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-199"
    }
  }, [_vm._v("Evaluation and appraisal process involve evaluating the presence (or potential presence) and extent of oil and gas reserves that have been indicated by G&G")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-200"
    }
  }, [_vm._v(" testing and exploratory drilling")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-201"
    }
  }, [_vm._v(". Exploratory wells")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-202"
    }
  }, [_vm._v(" may have found reserves; however, further evaluation and appraisal are often required in order to justify the capital expenditures that will be necessary to develop and produce the reserves—in other words confirming that the reserves are present in commercially producible quantities.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-202"
    }
  }, [_vm._v("After one or more successful exploratory wells have been drilled into a particular reservoir")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-203"
    }
  }, [_vm._v(", additional wells, referred to as appraisal wells")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-204"
    }
  }, [_vm._v(", are often drilled. This may be required by the contract and/or may be necessary in order to determine the commercial potential of the reservoir. The information gathered through drilling, testing, and appraisal are utilized in formulating the overall plan for developing and producing the newly discovered reserves.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-204"
    }
  }, [_vm._v("In U.S. operations, especially in areas with a history of production, when an exploratory well finds reserves, the E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-205"
    }
  }, [_vm._v(" company may move quickly into development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-206"
    }
  }, [_vm._v(". This is particularly likely in onshore operations in locations where an existing transportation and marketing infrastructure exists. In U.S. domestic offshore operations, the market and transportation infrastructure may also be in place; however, drilling of additional wells may be necessary in order to determine whether the reserves")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-207"
    }
  }, [_vm._v(" are sufficient to warrant construction of production platforms, pipelines, and facilities required to process and transport the production to the point of sale.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-207"
    }
  }, [_vm._v("In some locations outside the U.S., extensive appraisal and evaluation")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-208"
    }
  }, [_vm._v(" are likely to be necessary. PSC and risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-209"
    }
  }, [_vm._v(" often specify specific appraisal activities that must be carried out by the contractor in the event that an exploratory well indicates the presence of oil and gas. Extensive appraisal and evaluation are critical in locations where there is little or no preexisting infrastructure for the production and marketing of the oil and gas or in frontier areas with limited history of oil and gas production where there may be little existing knowledge of the geological conditions prevailing in the area and of the potential for commercial oil and gas production.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-009"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-209"
    }
  }, [_vm._v("Development Operations")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-210"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-210"
    }
  }, [_vm._v("After the formulation of a development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-211"
    }
  }, [_vm._v(" plan, companies typically commence development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-212"
    }
  }, [_vm._v(" activities. This involves undertaking the steps necessary to actually achieve commercial production. Development activities may involve:")])]), _c('ul', [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-212"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("a. Drilling additional wells necessary to produce the commercial reserves")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-213"
    }
  }, [_vm._v(";")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-213"
    }
  }, [_vm._v("b. Constructing platforms and gas treatment plants;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-213"
    }
  }, [_vm._v("c. Installing equipment and constructing facilities necessary for getting the oil and gas to the surface and for handling, storing, and processing or treating the oil and gas;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-213"
    }
  }, [_vm._v("d. Constructing gathering systems, storage facilities, and waste disposal systems.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-213"
    }
  }, [_vm._v("Development activities often continue into the production phase")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-214"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-214"
    }
  }, [_vm._v("In some contracts,")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-215"
    }
  }, [_vm._v(" undertaking development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-216"
    }
  }, [_vm._v(" activities may also signal a change in working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-217"
    }
  }, [_vm._v("s. As discussed earlier, typically in PSCs and sometimes in concession contracts")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-218"
    }
  }, [_vm._v(" and risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-219"
    }
  }, [_vm._v(", the government (through the state-owned oil company) has the option to participate in development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-220"
    }
  }, [_vm._v(" and production. If this is the case, the contractor has incurred all of the costs and risks associated with exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-221"
    }
  }, [_vm._v(" and appraisal. Once the information obtained during exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-222"
    }
  }, [_vm._v(" and appraisal has been analyzed, the state-owned oil company may exercise its option to participate. After the state-owned oil company’s level of participation has been determined (often up to a maximum of a 51% working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-223"
    }
  }, [_vm._v("), development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-224"
    }
  }, [_vm._v(" operations move forward with each company paying their proportionate (working interest) share of costs.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-010"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-224"
    }
  }, [_vm._v("Production Operations")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-224"
    }
  }, [_vm._v("The production activities involve extracting the oil and gas from the reservoir")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-225"
    }
  }, [_vm._v(" and treating the oil and gas in order to assure that it meets transportation and or marketing standards. Production activities include gathering the oil and gas from various wells in the area, storing the oil and gas, treating the oil and gas to remove basic sediment and water (BS&W), field separation of the gas from the oil, and storage or transportation of the oil and gas to the point of sale or to a refinery. Production activities are typically deemed to have ended when oil or gas flows out of the outlet value on the field production facility. During the production phase")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-226"
    }
  }, [_vm._v(", the working interest owners")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-227"
    }
  }, [_vm._v(" typically share the cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-228"
    }
  }, [_vm._v(" of production in proportion to their working interest. After the development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-229"
    }
  }, [_vm._v(" or even production has begun, additional evaluation, including G&G")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-230"
    }
  }, [_vm._v(" activities and even exploratory drilling, may be warranted.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-011"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-230"
    }
  }, [_vm._v("Decommissioning and Abandonment Operations")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-231"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-231"
    }
  }, [_vm._v("Throughout the productive life of a field, some wells may reach the end of their productive lives, and thus plugging and abandonment of those wells is a necessary part of the production process for the field. Likewise, certain pieces of equipment may reach the end of their productive life and require replacement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-232"
    }
  }, [_vm._v(" and removal. As the reserves in a reservoir")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-233"
    }
  }, [_vm._v(" are produced and a field moves into the latter stages of production, the cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-234"
    }
  }, [_vm._v(" of production typically gets higher and higher. Eventually "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("management may decide that it is time to plug and abandon the remaining wells, remove equipment, and restore the environment to its pre-existing condition. This process is referred to as decommissioning and abandonment. This process may be relatively straightforward (such as onshore locations in the U.S.) or extremely expensive and complex. For example, decommissioning of an offshore platform includes: obtaining all necessary permits and inspections, flushing and cleaning residual hydrocarbons from the tanks, piping, and processing equipment, removal of platform equipment, removing marine growth from subsea equipment, and transportation of all equipment to shore to be salvaged or scrapped. The specific operations depend on many factors including the specific type and location of the operations. The cost")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-235"
    }
  }, [_vm._v(" of decommissioning and closure likewise depend on the nature and location of the operations but is likely to be a very expensive undertaking.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-235"
    }
  }, [_vm._v("A common provision that appears in PSCs and risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-236"
    }
  }, [_vm._v(" is that ownership of the equipment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-237"
    }
  }, [_vm._v(" and facilities passes to the state-owned oil company. The transfer of ownership along with the high cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-238"
    }
  }, [_vm._v(" of decommissioning and closure at a time when there is little or no production has led to many disputes and considerable controversy in the industry. Most agreements provide specific language dealing with how decommissioning and abandonment is to be managed and paid for.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-012"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-238"
    }
  }, [_vm._v("Overlap of Operations in Various Phases")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-239"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-239"
    }
  }, [_vm._v("Theoretically, the different phases of upstream operations occur in a sequential order and are readily identifiable. In reality, however, this virtually never occurs. The different phases typically overlap, occur simultaneously, or even occur in a completely different order than in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig1-1"
    }
  }, [_vm._v("Figure 1-1")]), _vm._v(". For example, several years into the production phase"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-240"
    }
  }, [_vm._v(", a company may test for the presence of previously unproven reserves")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-241"
    }
  }, [_vm._v(" in a previously productive area. Many facilities are likely to be used during multiple phases. For instance, an office may be used to manage equipment and personnel employed in exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-242"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-243"
    }
  }, [_vm._v(", and production activities and also to manage the sale of products. If the phase of operations plays a role in determining the accounting treatment of various costs, it may be necessary to identify and understand the nature and significance of the overlap of the various phases. Often complex cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-244"
    }
  }, [_vm._v(" allocation processes may be involved in getting costs allocated between the parties involved and between the various phases of operations. These accounting issues are discussed in detail in ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#chap-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 4")]), _vm._v(" - "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#chap-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(".")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Mineral Interest"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-245"
    }
  }, [_vm._v(" Basics")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-245"
    }
  }, [_vm._v("Once an E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-246"
    }
  }, [_vm._v(" company has identified an area where there are known or potential oil and gas reserves")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-247"
    }
  }, [_vm._v(", the company may seek to acquire the right to explore, develop, and produce those reserves. This discussion focuses on the most common types of mineral rights and methods of acquiring them. These basics apply to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("mineral interest")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-248"
    }
  }, [_vm._v(" and rights regardless of the location or specific contracts used to acquire them.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-013"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-248"
    }
  }, [_vm._v("Mineral Interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-249"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-249"
    }
  }, [_vm._v("A mineral interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-250"
    }
  }, [_vm._v(" is an economic interest or ownership of minerals")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-251"
    }
  }, [_vm._v(" in place, giving the owner the right to a share of the minerals produced either in kind or in the monetary proceeds from the sale of the minerals. ("), _c('b', [_vm._v("Sharing in kind")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-252"
    }
  }, [_vm._v(" means the owner has elected to receive the oil and gas itself rather than the monetary proceeds from the sale of the oil and gas.) When the owner of the mineral interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-253"
    }
  }, [_vm._v(" enters into a contract to explore, develop, and produce oil and gas from a previously unleased property, two types of mineral rights are created: a working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-254"
    }
  }, [_vm._v(" and a royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-255"
    }
  }, [_vm._v(". Descriptions of the basic types of mineral rights are given in the following paragraphs. A more detailed discussion of these rights or interests is provided in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002"
    }
  }, [_vm._v("chapter 2")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-014"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Royalty Interest"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-256"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-256"
    }
  }, [_vm._v("A royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-257"
    }
  }, [_vm._v(" is typically created when a mineral contract is executed. The royalty interest is retained by the original owner of the mineral")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-258"
    }
  }, [_vm._v(" rights. The royalty interest owner typically receives a specified portion of the gross revenue")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-259"
    }
  }, [_vm._v(" from any oil and gas produced from the property. The royalty owner does not pay any of the costs associated with exploring, developing, or operating the property. However, the royalty owner may be required to share in midstream costs necessary to get the product into marketable condition, such as dehydration, compression, gathering and liquid extraction costs, or downstream costs related to refining and transporting the saleable product to the downstream buyer.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-015"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-259"
    }
  }, [_vm._v("Working Interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-260"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-260"
    }
  }, [_vm._v("The working interest is created when the contract is signed. The working interest owner")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-261"
    }
  }, [_vm._v(" or owners are responsible for paying all (100%) of the cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-262"
    }
  }, [_vm._v(" of exploring, drilling, developing, and producing the property. The working interest’s share of revenue, however, is the amount that remains after deducting the share of the royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-263"
    }
  }, [_vm._v(" and other non-working interests")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-264"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-264"
    }
  }, [_vm._v("Assume that representatives of the government of Country A sign an agreement whereby X Company agrees to pay all of the costs to explore, develop, and produce oil and gas in a specific location in the country. The cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-265"
    }
  }, [_vm._v(" and revenue sharing")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-266"
    }
  }, [_vm._v(" in this example is diagrammed in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig1-2"
    }
  }, [_vm._v("Figure 1-2")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Working interest percentages are stated in terms of how the costs are to be paid. In this illustration, the working interest"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-267"
    }
  }, [_vm._v(" is referred to as a 100% working interest because the working interest owner, ABC Company, is responsible for paying 100% of the cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-268"
    }
  }, [_vm._v(" of exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-269"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-270"
    }
  }, [_vm._v(", and production. The royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-271"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("percentage is stated in terms of the share of gross production or gross revenue from the property. In this example the royalty interest owner (the government) would receive 10% of the gross revenues but pay none of the exploration")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-272"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-273"
    }
  }, [_vm._v(", and production costs.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig1-2"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-273"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 1-2. Basic royalty and working interest",
      "src": "images/Fig1-2.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-273"
    }
  }, [_c('b', [_vm._v("Fig. 1-2.")]), _vm._v(" Basic royalty and working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-274"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-275"
    }
  }, [_vm._v("A joint working interest results from two or more parties sharing the working interest. Sharing the working interest provides a means for companies to share the costs and risks of operations. In these arrangements the working interest owners")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-276"
    }
  }, [_vm._v(" share control of jointly owned, undivided interests in oil and gas assets. In a joint working interest arrangement, one of the parties is typically designated as the operator of the property, and all the other working interest owners are referred to as non-operators. The operator manages the day-to-day operations of the property with the non-operators sharing in the joint ownership")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-277"
    }
  }, [_vm._v(" of the underlying assets. Both the operator and the non-operators are responsible for paying their proportionate share of any costs incurred.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-277"
    }
  }, [_vm._v("Most joint oil and gas operations are not set up as separate legal entities; rather, the joint operations involve undivided interests in jointly owned and controlled assets. In the event that the joint operation is incorporated or otherwise established as a separate legal entity, consolidation or use of the equity method of accounting may be required. If a legal partnership or legal joint venture is established, other accounting and taxation issues may result.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-277"
    }
  }, [_vm._v("Continuing with the illustration above, assume that Company X gets the government’s approval to sell 50% of its working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-278"
    }
  }, [_vm._v(" to Company Z. ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig1-3"
    }
  }, [_vm._v("Figure 1-3")]), _vm._v(" provides a simple diagram of the cost"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-279"
    }
  }, [_vm._v(" and revenue split in a situation that involves a basic royalty and a joint working interest.")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-279"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  })]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig1-3"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-279"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 1-3. Basic royalty with joint working interest",
      "src": "images/Fig1-3.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-279"
    }
  }, [_c('b', [_vm._v("Fig. 1-3.")]), _vm._v(" Basic royalty with joint working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-280"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-280"
    }
  }, [_vm._v("Notice in the example the government’s royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-281"
    }
  }, [_vm._v(" does not change. The original royalty is typically unaffected by subsequent transactions unless the royalty owner explicitly agrees that the royalty is to be altered or adjusted. Furthermore, in this example the government of Country A was not a party to the subsequent agreement between Company X and Company Z; each company owns 50% of the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-282"
    }
  }, [_vm._v(" and thus each pays 50% of the costs. Since the original agreement resulted in only 90% of the net revenues being acquired by Company X, Company X can only convey 50% of the 90% revenue interest it owned to Company Z. In this example, Company X chose to sell 50% of its working interest. In basic lease agreements in the U.S., the working interest owners")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-283"
    }
  }, [_vm._v(" are typically free to convey all or part of their working interest without first getting permission from the royalty interest owner(s). In international contracts,")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-284"
    }
  }, [_vm._v(" it is often necessary for the working interest owner to first obtain approval from the government or the state-owned oil company before proceeding with any sale or conveyance of its working interest.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-284"
    }
  }, [_vm._v("Typically, when multiple parties share the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-285"
    }
  }, [_vm._v(", a joint operating agreement is executed. Joint operating agreements"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-286"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-286"
    }
  }, [_vm._v(" are discussed in detail in ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#chap-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 13")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another basic type of interest that is often observed in international oil and gas operations is an"), _c('b', [_vm._v(" overriding royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-287"
    }
  }, [_c('b', [_vm._v(" (ORI")]), _vm._v(")"), _c('b', [_vm._v(".")]), _vm._v(" An ORI is created out of a working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-288"
    }
  }, [_vm._v("; however, it is similar to a royalty interest in that the owner of an ORI does not typically bear any of the costs associated with exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-289"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-290"
    }
  }, [_vm._v(", or upstream operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-291"
    }
  }, [_vm._v(". The ORI’s share of revenue")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-292"
    }
  }, [_vm._v(" is typically stated as a percentage of the revenue accruing to the working interest from which it was created. An overriding royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-293"
    }
  }, [_vm._v(" may be created either by being retained by the working interest owner")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-294"
    }
  }, [_vm._v(" when the working interest is sold or conveyed or by being "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("“carved out")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-295"
    }
  }, [_vm._v("” of a working interest. A carved-out ORI is created when the working interest owner retains its working interest but sells or conveys an ORI to another party.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-295"
    }
  }, [_vm._v("Continuing with the example above, assume that Company Z decides to carve out and convey a 20% ORI to a lending institution as collateral for a loan. ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig1-4"
    }
  }, [_vm._v("Figure 1-4")]), _vm._v(" illustrates the cost"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-296"
    }
  }, [_vm._v(" and revenue splits when an overriding royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-297"
    }
  }, [_vm._v(" is created from a joint working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-298"
    }
  }, [_vm._v(".")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig1-4"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-298"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 1-4. Basic overriding royalty interest",
      "src": "images/Fig1-4.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-298"
    }
  }, [_c('b', [_vm._v("Fig. 1-4.")]), _vm._v(" Basic overriding royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-299"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-299"
    }
  }, [_vm._v("The ORI is equal to 20% of the net revenue that Company Z is entitled to or 20% of 45% = 36%. However, Company Z continues to have a 50% working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-300"
    }
  }, [_vm._v(" and therefore is responsible for 50% of the upstream exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-301"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-302"
    }
  }, [_vm._v(", or upstream operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-303"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-303"
    }
  }, [_c('b', [_vm._v("A net profit interest (NPI)")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-304"
    }
  }, [_vm._v(" may be created in the original conveyance agreement or it may be created from the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-305"
    }
  }, [_vm._v(" either by being retained by the working interest owner when the working interest is conveyed or by being carved out")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-306"
    }
  }, [_vm._v(". Net profits interests are typically stated as a specified percentage of net profit versus a percentage of the gross revenues. The allowed deductions from gross revenue")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-307"
    }
  }, [_vm._v("s that would be deducted in calculating net profit are usually specified in the underlying agreement. While net profits interest owners are entitled to a percentage of the profits, they are not responsible for paying any portion of the upstream costs of exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-308"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-309"
    }
  }, [_vm._v(", or operations. Furthermore, the NPI owner is not typically responsible for repaying losses that might be incurred in relation to the property. Any such losses would typically be the responsibility of the working interest from which the NPI was originally created.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-309"
    }
  }, [_vm._v("The mineral interests that may be encountered in different countries vary from one country to another. The specific mineral interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-310"
    }
  }, [_vm._v("s encountered in any given location are largely dictated by the local laws governing mineral resources. While "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("other types of mineral interests exist, the basic mineral interests described in this section are, by far, the most common.")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-310"
    }
  }, [_vm._v("Different Accounting Practices for Different Purposes")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-310"
    }
  }, [_vm._v("An international oil and gas company provides accounting information to a number of different constituents. The principles, standards, rules, and requirements used in the accounting process differ depending on how the accounting information will be used. The four basic types of accounting are: financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-311"
    }
  }, [_vm._v(", income tax accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-312"
    }
  }, [_vm._v(", contract accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-313"
    }
  }, [_vm._v(", and managerial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-314"
    }
  }, [_vm._v(". Each of these has its own standards, principles, rules, and requirements. It is important to understand the differences in these four categories and how accounting systems are designed to meet the informational needs of international oil and gas companies. ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig1-5"
    }
  }, [_vm._v("Figure 1-5")]), _vm._v(" illustrates four basic types of accounting and the sources of statutes, standards, and guidelines. A brief overview of each of these types of accounting appears below. This overview provides a foundation for much of the discussion throughout the remainder of this book.")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig1-5"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 1-5. Different types of accounting for different purposes",
      "src": "images/Fig1-5.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Fig. 1-5.")]), _vm._v(" Different types of accounting for different purposes")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-016"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Financial Accounting"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-315"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-315"
    }
  }, [_vm._v("Financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-316"
    }
  }, [_vm._v(" refers to the information generated for external financial reporting purposes. The term financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-317"
    }
  }, [_vm._v(" includes measuring and recording the economic activities of a business and communicating the information to users outside the business. Although many individuals and entities use financial accounting information, the FASB and the IASB")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-318"
    }
  }, [_vm._v(" have both indicated that investors and creditors are the primary targets of financial accounting information. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("According to FASB,"), _c('i', [_vm._v(" Statement of Financial Accounting")])])]), _c('i', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-319"
    }
  }, [_vm._v(" Concepts (SFSC) No. 8")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-319"
    }
  }, [_vm._v(", “")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(", The Objective of General Purpose Financial Reporting, and "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#chap-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(", Qualitative Characteristics of Useful Financial Information”:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("The objective of general purpose financial reporting is to provide financial information about the reporting entity that is useful to existing and potential investors, lenders, and other creditors in making decisions about providing resources to the entity. Those decisions involve buying, selling, or holding equity and debt instruments and providing or settling loans and other forms of credit.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_vm._v("Decisions by existing and potential investors about buying, selling, or holding equity and debt instruments depend on the returns that they expect from an investment in those instruments; for example, dividends, principal and interest payments, or market price increases. Similarly, decisions by existing and potential lenders and other creditors about providing or settling loans and other forms of credit depend on the principal and interest payments or other returns that they expect. Investors’, lenders’, and other creditors’ expectations about returns depend on their assessment of the amount, timing, and uncertainty of (the prospects for) future net cash inflows to the entity. Consequently, existing and potential investors, lenders, and other creditors need information to help them assess the prospects for future net cash inflows to an entity.")]), _vm._v(" (par. OB2- OB3)")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Investors and creditors are individuals and institutions who invest in business entities either by purchasing stock in the firm or by extending credit. Investors and creditors generally are seeking a return on, and of, their investments either in the form of dividends, stock appreciation, payment of interest, and repayment of principle. In order to pay dividends, interest, and loan principle, a business must have cash. Therefore, when investors and creditors attempt to choose between investments in alternative business enterprises, a goal of their analysis is to assess the likelihood that an entity will have net positive cash flows in the future. The primary source of information that is used in this process is information derived from the financial accounting"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-320"
    }
  }, [_vm._v(" system of the entity.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-320"
    }
  }, [_vm._v("Externally released financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-321"
    }
  }, [_vm._v(" information related to publicly traded companies must be prepared in conformity with the accounting standards governing the specific local reporting requirements and the regulations issued by the oversight boards of the securities exchange(s) on which an entity is traded. For example, in the U.S., domestic publicly traded companies must adhere to U.S. GAAP")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-322"
    }
  }, [_vm._v(" and SEC regulations")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-323"
    }
  }, [_vm._v(" while foreign registrants may either use U.S. GAAP or IFRS")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-324"
    }
  }, [_vm._v(". The financial accounting standards in global markets are discussed in detail earlier in this chapter.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-017"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-324"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  })]), _c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-324"
    }
  }, [_vm._v("Income Tax Accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-325"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-325"
    }
  }, [_vm._v("The objective of income tax accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-326"
    }
  }, [_vm._v(" is to determine the amount of income taxes entities must pay according to the income tax laws governing their operations. Income tax rules may refer to the capitalization versus expensing of a cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-327"
    }
  }, [_vm._v("; however, the tax rules are likely to differ considerably from the applicable financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-328"
    }
  }, [_vm._v(" standards. Similarly, the determination of gross income and taxable income for income tax purposes is different from the determination of revenue and net income for financial accounting purposes.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-328"
    }
  }, [_vm._v("In addition to income taxes, companies engaged in oil and gas operations must determine and pay a number of other types of taxes. In addition to import duties and employment-related taxes, petroleum operations are frequently subject to an array of additional taxes including severance or production taxes, value added taxes, and special petroleum taxes. For example, state and local governments regularly impose various taxes on petroleum operations. These petroleum taxes may be based on the quantity (e.g., number of barrels) or on the value (e.g., sales price) of minerals produced.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-018"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-328"
    }
  }, [_vm._v("Contract Accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-329"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-329"
    }
  }, [_vm._v("Oil and gas contracts are legal documents that include numerous accounting-related provisions. Contract accounting requires accountants to read, interpret, and comply with the provisions of any enacted contracts. The single most pervasive principle in contract accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-330"
    }
  }, [_vm._v(" is that the accountant"), _c('i', [_vm._v(" must")]), _vm._v(" adhere to the terms of the contract. Unless use of financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-331"
    }
  }, [_vm._v(" standards or tax statutes is specifically required by a contract, financial accounting standards cannot and do not dictate contract accounting practices. Similarly, contract accounting provisions cannot and do not dictate financial accounting practices. The principles governing contract accounting are the terms of the applicable contracts and agreements.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-331"
    }
  }, [_vm._v("In the oil and gas industry, contracts (e.g., leases, concessionary agreements, PSC, service agreements, etc.) define the relationship between the owner of the mineral interes")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-332"
    }
  }, [_vm._v("ts and the E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-333"
    }
  }, [_vm._v(" companies seeking to explore, develop, and produce oil and gas resources. In many countries the mineral rights are owned by the local government and managed by national oil companies. It is common for multiple E&P companies to be involved in the same license area. In these situations, the E&P companies typically enter into a second type of contract referred to as a joint operating agreement. Joint operating agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-334"
    }
  }, [_vm._v(" govern how a specific property is to be managed and how costs and production are to be shared. In these agreements, one of the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-335"
    }
  }, [_vm._v(" owners is typically designated as the operator while the other company(ies) is (are) the non-operator(s). The operator is responsible for paying vendors for services they have rendered and goods they have supplied. The operator must accurately record and report all costs incurred in exploring, drilling, developing, and producing the joint property to the non-operators. Joint "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("operating agreements typically include a section referred to as the accounting procedure")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-336"
    }
  }, [_vm._v(". The accounting procedure")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-337"
    }
  }, [_vm._v(" addresses a number of accounting-related issues, including how all costs, whether directly or indirectly related to a specific operation, are to be shared between the working interest owners. The accounting procedure")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-338"
    }
  }, [_vm._v(" does not determine the financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-339"
    }
  }, [_vm._v(" treatment of costs and revenues.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-339"
    }
  }, [_vm._v("In the U.S. an organization called the Council of Petroleum Accountants Societies (COPAS)")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-340"
    }
  }, [_vm._v(" plays a significant role in the development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-341"
    }
  }, [_vm._v(" of the accounting procedures that frequently appear in joint operating agreements. Contracts utilized outside of the U.S. are not as standardized. However, the Association of International Petroleum Negotiators (AIPN)")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-342"
    }
  }, [_vm._v(" publishes model form international JOAs and model form international accounting procedures. Neither COPAS nor the AIPN has statutory authority; however, if a COPAS or AIPN model accounting procedure")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-343"
    }
  }, [_vm._v(" is included in a contract, the parties to the contract must comply with the provisions of the procedure.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-343"
    }
  }, [_vm._v("Regardless of the type of contract or contracts that govern the petroleum operation, a considerable amount of accounting effort is required. It is imperative that all of the provisions of the applicable accounting procedure")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-344"
    }
  }, [_vm._v("(s) be carefully analyzed and complied with. This includes correctly classifying costs as being direct versus indirect and/or recoverable versus nonrecoverable. Typically, the accounting function plays an important role in assuring that the operator is in compliance with all of the terms of the contract, including the accounting procedure")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-345"
    }
  }, [_vm._v(". Additionally, significant accounting effort is required on the part of the non-operators, not only in accounting for their own costs and revenues, but also in monitoring the operator’s spending, financial activities, and overall contract compliance. Once spending commences on approved projects, the operator of a property generally must provide the non-operator(s) with sufficient information to enable the non-operator(s) to classify the costs in their own accounting system based on their individual financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-346"
    }
  }, [_vm._v(" policies and procedures. The operator does not dictate a non-operator’s financial accounting reatment of costs.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-019"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-346"
    }
  }, [_vm._v("Managerial Accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-347"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-347"
    }
  }, [_vm._v("The term managerial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-348"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-349"
    }
  }, [_vm._v(" is used here to refer to internal accounting and reporting that is required in order for management to operate the company efficiently and effectively. Examples include budgeting, cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-350"
    }
  }, [_vm._v(" analysis and control, and performance reporting. The distinction between financial, tax, contract, and managerial accounting is that in managerial accounting, company policy governs the policies and procedures to be employed. In other words, no external board, agency, or contract dictates the accounting policies and procedures. The policies and procedures related to managerial accounting are determined by the needs of the specific organization and are designed to aid in managerial decision-making.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-020"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-350"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  })]), _c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-350"
    }
  }, [_vm._v("Accounting Systems Design")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-351"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-351"
    }
  }, [_vm._v("Companies do not have multiple accounting systems. They have one, single accounting system. As is illustrated in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig1-6"
    }
  }, [_vm._v("Figure 1-6")]), _vm._v(", rather than having four different accounting systems, information must be entered into the accounting system in such a way as to:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_vm._v("Permit preparation of financial accounting"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-352"
    }
  }, [_vm._v(" statements, reports, and disclosures;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-352"
    }
  }, [_vm._v("Comply with tax laws and statutes in preparing income tax returns and reports;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-352"
    }
  }, [_vm._v("Apply contract terms in the preparation of joint interest billing")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-353"
    }
  }, [_vm._v("s and detailed reports to royalty owners, governments, and joint working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-354"
    }
  }, [_vm._v(" owners;")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-354"
    }
  }, [_vm._v("Prepare internal reports and analyses that maximize in compliance with company-specific policies and procedures.")])])])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig1-6"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-354"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 1-6. Flow of data through the accounting system",
      "src": "images/Fig1-6.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-354"
    }
  }, [_c('b', [_vm._v("Fig. 1-6.")]), _vm._v(" Flow of data through the accounting system")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-354"
    }
  }, [_vm._v("It is important that the accountant is aware of the various requirements associated with each of these different types of accounting. This process is the source of much confusion since each cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-355"
    }
  }, [_vm._v(" incurred should be evaluated for its financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-356"
    }
  }, [_vm._v(" treatment, its income tax treatment, its contract treatment, and its treatment in the company’s budget or other internal reports.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-356"
    }
  }, [_vm._v("Accounting systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-357"
    }
  }, [_vm._v(" are typically designed such that information is initially entered in accordance with the appropriate financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-358"
    }
  }, [_vm._v(" treatment. For example, a cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-359"
    }
  }, [_vm._v(" that has been incurred must be capitalized or expensed (and thus charged to a specific account code) based on the company’s financial accounting policies and practices. When journal entry data is entered into the accounting system, it contains critical information (e.g., purchase date, property code, interest type, etc.) that is necessary in order to generate reports and statements, including those required for financial accounting, tax accounting, contract accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-360"
    }
  }, [_vm._v(", and managerial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-361"
    }
  }, [_vm._v(". In this way all of the necessary data is available in one, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("single system regardless of the accounting purpose. This makes it imperative that information is correctly entered into the system.")])])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig1-7"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-361"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 1-7. Financial accounting data entry",
      "src": "images/Fig1-7.jpg"
    }
  })])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-361"
    }
  }, [_c('b', [_vm._v("Fig. 1-7.")]), _vm._v(" Financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-362"
    }
  }, [_vm._v(" data entry")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-362"
    }
  }, [_vm._v("According to ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig1-7"
    }
  }, [_vm._v("Figure 1-7")]), _vm._v(", accountants must analyze, classify, and enter the data according to the correct financial accounting"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-363"
    }
  }, [_vm._v(" treatment so that financial statements and reports can be prepared. Compliance with tax laws and statutes, contractual commitments, and managerial policies can only be achieved when financial accounting principles and standards have been correctly applied at the time the data is initially entered into the system. Getting the financial accounting wrong may mean that key income tax figures are incorrect, contractual mandates are not correctly complied with, and managerial reports communicate inaccurate and misleading information. According to ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig1-8"
    }
  }, [_vm._v("Figure 1-8")]), _vm._v(", incorrect financial accounting data affects virtually all of the other information generated from the accounting system.")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig1-8"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 1-8. Financial accounting must be correct",
      "src": "images/Fig1-8.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Fig. 1-8.")]), _vm._v(" Financial accounting"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-364"
    }
  }, [_vm._v(" must be correct")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-364"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("This book focuses primarily on financial accounting")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-365"
    }
  }, [_vm._v(". Various contracts used in international oil and gas operations are discussed in detail in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002"
    }
  }, [_vm._v("chapter 2")]), _vm._v(". Managerial reports and performance metrics are discussed in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#chap-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 9")]), _vm._v("-"), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#chap-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(". Since tax laws vary from one jurisdiction to another, income taxes are not covered in this book.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("________________")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-021"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("References")]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-001"
    }
  }, [_vm._v("Act 144. Laws of Malaysia,"), _c('i', [_vm._v(" Petroleum Development Act of 1974")]), _vm._v(" (as of June 2013).")]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-002"
    }
  }, [_vm._v("Financial Accounting"), _c('i', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-366"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-366"
    }
  }, [_vm._v(" Standards Board (2018)."), _c('i', [_vm._v(" Statement of Financial Accounting Concepts No. 8")]), _vm._v(", “Conceptual Framework for Financial Reporting.” Norwalk, CT.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-003"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-366"
    }
  }, [_vm._v("Securities and Exchange Commission."), _c('i', [_vm._v(" Reg. S-X Rule 4-10")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-367"
    }
  }, [_vm._v(", “Financial Accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-368"
    }
  }, [_vm._v(" and Reporting for Oil and Gas Producing Activities.” (2019)")])])])])])])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-368"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 69
// module chunks = 0